"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.callConsentHandlers = exports.setConsentCookie = exports.isConsentProvided = exports.getCookieConsentState = exports.COOKIE_DECLARATION_COOKIE_NAME = void 0;
var js_cookie_1 = __importDefault(require("js-cookie"));
exports.COOKIE_DECLARATION_COOKIE_NAME = "cookie-consent__state";
var COOKIE_DECLARATION_DEFAULT_STATE = {
    personalisation: false,
    analytics: false,
    marketing: false
};
/**
 * Helper function that provides initial state from the cookie.
 *
 * Read cookie and if it's present, parse and return the state. Otherwise - default state.
 */
var getCookieConsentState = function () {
    var _a;
    return (_a = js_cookie_1.default.getJSON(exports.COOKIE_DECLARATION_COOKIE_NAME)) !== null && _a !== void 0 ? _a : COOKIE_DECLARATION_DEFAULT_STATE;
};
exports.getCookieConsentState = getCookieConsentState;
/**
 * Helper function that gets the initial state of the banner.
 * If cookie is set, then user has provided consent to cookies, and we don't show the banner
 */
var isConsentProvided = function () { return Boolean(js_cookie_1.default.get(exports.COOKIE_DECLARATION_COOKIE_NAME)); };
exports.isConsentProvided = isConsentProvided;
/**
 * Handler that sets consent cookie
 */
var setConsentCookie = function (cookieConsentState, domain, secure) {
    js_cookie_1.default.set(exports.COOKIE_DECLARATION_COOKIE_NAME, cookieConsentState, {
        domain: domain,
        secure: secure,
        expires: 365,
        path: "/",
    });
};
exports.setConsentCookie = setConsentCookie;
/**
 * Helper that calls provided consent change handlers if state was updated
 */
var callConsentHandlers = function (handlers, initialState, updatedState) {
    var keys = Object.keys(updatedState);
    keys.forEach(function (key) {
        var wasUpdated = initialState[key] !== updatedState[key];
        var currentHandlers = handlers[key];
        var isAccepted = updatedState[key];
        if (wasUpdated && currentHandlers) {
            isAccepted
                // Check if callback exists and call it
                ? currentHandlers.onAccept && currentHandlers.onAccept()
                : currentHandlers.onDecline && currentHandlers.onDecline();
        }
    });
};
exports.callConsentHandlers = callConsentHandlers;
